import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PRODUCT_TYPE_CATEGORIES } from '../../types/product-definitions';
import { debounceTime, Observable, Subject } from 'rxjs';
import { PagedResponse } from '../../types/PagedResponse';
import { Product } from '../../types/Product';
import { ProductService } from '../../services/products.service';
import { LoadingComponent } from "@digi-america/shared";
import { AsyncPipe, CommonModule } from '@angular/common';
import { ProductCardComponent } from '../../components/product-card/product-card.component';

type ProductSearchResultSubcategory = {
  label: string;
  image: string;
  products: Product[];
}[];

type ProductSearchResult = {
  header: string;
  subcategories: ProductSearchResultSubcategory;
}[];

@Component({
  selector: 'app-product-type-select',
  imports: [CommonModule, RouterLink, LoadingComponent, AsyncPipe, ProductCardComponent],
  templateUrl: './product-type-select.component.html',
  styleUrl: './product-type-select.component.scss',
  standalone: true
})
export class ProductTypeSelectComponent implements OnInit, OnDestroy {
  public productCategories = PRODUCT_TYPE_CATEGORIES;

  public quoteId?: string = undefined;

  public products$!: Observable<PagedResponse<Product>>;

  public searchInput$: Subject<string> = new Subject<string>();
  public searchValue: string = '';

  constructor(
    private productsService: ProductService,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.quoteId = params['quoteId'];
    });

    this.searchInput$.pipe(debounceTime(500)).subscribe((searchTerm) => {
      this.searchValue = searchTerm;
      if (this.searchValue === "") {
        this.products$
      }
      this.updateSearch();
    });
  }

  ngOnDestroy() {
    this.searchInput$.complete();
  }

  public updateSearch(): void {
    this.products$ = this.productsService.searchProduct("all", {}, this.searchValue, "sku", 1, 10);
  }

  public createProductList(products: PagedResponse<Product>): ProductSearchResult {
    let results: ProductSearchResult = [];

    for (let category of this.productCategories) {
      let subcategories: ProductSearchResultSubcategory = [];
      for (let subcategory of category.types) {
        let subProducts = products.data.filter(p => p.type == subcategory.id);
        if (subProducts.length) {
          subcategories.push({ label: subcategory.label, image: subcategory.image, products: subProducts });
        }
      }

      if (subcategories.length) {
        results.push({ header: category.name, subcategories: subcategories });
      }
    }

    return results;
  }
}
